import CardDetailWrapper from "modules/cards/card-detail/CardDetailWrapper";
import React from "react";

const CardDetailPage: React.FC = () => {
  return <CardDetailWrapper />;
};

export default CardDetailPage;
